module.exports = __webpack_public_path__ + "img/elf.8b832752.jpeg";